export type OpenState = "open" | "closed" | "mixed";

export function useLegalTextDisclosure(
  parentEl: MaybeRefOrGetter<HTMLElement | undefined>,
  hasOpened: boolean
) {
  const openState = ref<OpenState>(hasOpened ? "mixed" : "closed");

  const getAllLegalTextDisclosures = (open: boolean) => {
    const panels = [
      ...document.querySelectorAll(
        `[aria-expanded=${open ? "true" : "false"}][aria-label=disclosure]`
      ),
    ] as HTMLElement[];

    return panels;
  };

  const openAll = async () => {
    const panels = getAllLegalTextDisclosures(false);
    panels.forEach((panel) => panel.click());
    await nextTick();
    if (getAllLegalTextDisclosures(false).length !== 0) {
      await openAll();
    } else {
      openState.value = "open";
    }
  };

  const closeAll = () => {
    const panels = getAllLegalTextDisclosures(true);
    panels.forEach((panel) => panel.click());

    openState.value = "closed";
  };

  const toggleCollapse = () => {
    const openedPanel = toValue(parentEl)?.querySelector(
      `[aria-expanded="true"][aria-label=disclosure]`
    );
    const closedPanel = toValue(parentEl)?.querySelector(
      `[aria-expanded="false"][aria-label=disclosure]`
    );

    if (!openedPanel) {
      return (openState.value = "closed");
    }

    if (!closedPanel) {
      return (openState.value = "open");
    }

    openState.value = "mixed";
  };

  return { openAll, closeAll, toggleCollapse, openState };
}
